import React from 'react';
import PropTypes from 'prop-types';
import Grid from '../components/Grid.jsx';
import TextField from '../components/TextField.jsx';

const GridTextField = ({ gridProps, ...props }) => {
  return (
    <Grid item {...gridProps}>
      <TextField {...props} />
    </Grid>
  );
};

GridTextField.propTypes = {
  gridProps: PropTypes.object.isRequired,
};

export default GridTextField;
